module.exports = __webpack_public_path__ + "img/img_banner_index_02.f6306b23.jpg";